import {EventSource} from "./EventSource.js";
import {skin} from "../utils/Skin.js";
import {chatClientState} from "./ChatClientState.js";

const TYPING_DELAY = 6000;

export class MessageEditor extends EventSource {
	/**
	 * @param {jQuery} containerElement - element which will be container of the widget
	 * @param {string} me - ID of the current user
	 * @param {function} sendFunction - sending function returning Promise
	 * @param {SharedContext} context - page context
	 */
	constructor(containerElement, me, sendFunction, context) {
		super();
		this.container = containerElement;
		this.me = me;
		this.sender = sendFunction;
		this.chatId = null;
		this.context = context;
		this.install();
		this.typingTimeout = 0;
	}

	correctInputHeight() {
		const elm = this.input.get(0);
		elm.style.height = 'auto';
		elm.style.height = (elm.scrollHeight+2) + 'px';	// 2 for border width
	}

	install() {
		this.input = $("<textarea rows='1' class='message-editor'></textarea>");
		//this.input.css("height", this.input.get(0).scrollHeight + "px");
		this.input.on("input", this.correctInputHeight.bind(this));
		this.input
			.on("keydown", function(e) {
				if (e.keyCode === 13 /* enter */ && !e.shiftKey) {
					e.preventDefault();
					this.sendMessage();
				} else this.typing();
			}.bind(this))
			.on("input", function(e) {
				if (this.chatId != null) {
					chatClientState.setMsg(this.chatId, this.input.val());
				}
			}.bind(this));

		this.editorLayout = $("<div class='message-editor-layout'></div>");

		if (this.context) {
			this.shareLocIcn = $(Icon.fi("sight-cross", null, "margin-right:3px"));
			this.shareLocIcn.addClass("icn");
			this.editorLayout.append(this.shareLocIcn);
		}

		this.editorLayout.append(this.input);

		this.sendIcn = $(Icon.fi("send", null, "margin-left:2px"));
		this.sendIcn.addClass("icn");
		this.editorLayout.append(this.sendIcn);

		this.container.append(this.editorLayout);

		if (this.context) {
			this.shareLocIcn.on("click", this.shareContext.bind(this));
		}

		this.sendIcn.on("click", this.sendMessage.bind(this));
	}

	showChat(chatId) {
		if (chatId == null) this.input.val("");
		else {
			this.input.val(chatClientState.getMsg(chatId));
			this.correctInputHeight();
		}
		this.chatId = chatId;
	}

	typing() {
		if (this.typingTimeout !== 0) {
			window.clearTimeout(this.typingTimeout);
			this.typingTimeout = 0;
		} else this.typingStart();
		this.typingTimeout = window.setTimeout(this.typingEnd.bind(this), TYPING_DELAY);
	}

	typingStart() {
		this.fireEvent("typingstart", {});
	}

	typingEnd() {
		this.typingTimeout = 0;
		this.fireEvent("typingend", {});
	}

	shareContext() {
		const msg = { from: this.me, media: []};
		const txt = this.input.val().trim();
		if (txt.length > 0) {
			msg.media.push(MessageEditor.plaintext(txt));
		}
		const ctxMedia = { mime: "application/json" };
		let ctxDirect = null;
		if (typeof this.context === "function") ctxDirect = this.context();
		else ctxDirect = this.context;
		ctxMedia.text = JSON.stringify(ctxDirect);
		msg.media.push(ctxMedia);

		this.sendThis(msg);
	}

	/** Get content of editor and send it to the chat */
	sendMessage() {
		if (this.typingTimeout !== 0) {
			window.clearTimeout(this.typingTimeout);
			this.typingTimeout = 0;
		}
		const msg = { from: this.me, media: []};
		const ptMedia = MessageEditor.plaintext(this.input.val());
		msg.media.push(ptMedia);
		this.sendThis(msg);
	}

	sendThis(msg) {
		this.sender(msg).then((data) => {
			this.input.val("");
			chatClientState.setMsg(this.chatId, null);
			this.input.css("background-color", "var(--input-bg)");
			this.correctInputHeight();
		}).catch((err) => {
			// TODO display correct error to the user
			this.input.css("background-color", "var(-input-error-bg)");
		});
	}

	static plaintext(txt) {
		return {
			mime: "text/plain",
			text: txt
		};
	}
}
